import type { BillDetail } from "@/interfaces/bill.interface";
import { axiosInstance as axios } from "./axios.config";
import { getAppConfig } from "@/config/app-config";

export const fetchBills = async (): Promise<{ data: any }> => {
  return axios.get("/invoice_list/");
};

export const fetchBillDetail = async (
  id: number
): Promise<{ data: BillDetail }> => {
  return axios.get(`/invoice_detail/${id}/`);
};

export const creatNewBillRequest = async (billId: any): Promise<any> => {
  const { pagoticApiUrl } = getAppConfig();
  return await axios.post(`${pagoticApiUrl}/retry/${billId}/`, {});
};
